import type {Painter} from '../painter/types'
import {resolveSignColors} from './colors'
import type {BackgroundLayout, BgColor} from './layout'

/**
 * Paint the three nested rounded rectangles that make up a sign
 * background (contrast border, black edge, bg fill). Rows and overlays
 * are NOT painted here — that composition lives in the Sign Renderer
 * Module (`lib/sign-renderer`).
 */
export function paintBackground(p: Painter, layout: BackgroundLayout, bgColor: BgColor): void {
    const {width, height, contrastBorder, blackEdge, cornerRadius} = layout
    const colors = resolveSignColors(bgColor)
    const edgeOffset = contrastBorder
    const bgOffset = contrastBorder + blackEdge

    p.fillRoundedRect(colors.border, 0, 0, width, height, cornerRadius)

    if (blackEdge > 0) {
        const r = Math.max(0, cornerRadius - edgeOffset)
        p.fillRoundedRect(
            colors.edge,
            edgeOffset,
            edgeOffset,
            width - 2 * edgeOffset,
            height - 2 * edgeOffset,
            r
        )
    }

    {
        const r = Math.max(0, cornerRadius - bgOffset)
        p.fillRoundedRect(
            colors.bg,
            bgOffset,
            bgOffset,
            width - 2 * bgOffset,
            height - 2 * bgOffset,
            r
        )
    }
}
